module.exports = __webpack_public_path__ + "img/oneandmore.5e9895f0.png";